<template>
  <div v-title data-title="KPI告警监控">
    <div class="sms-content-main">
      <div class="filter-list">
        <div class="filter-item middle-filter-item">
          <div class="item-label">
            开始时间
          </div>
          <div class="item-component">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="filter.startDate"
                type="month"
                placeholder="选择月"
                format="yyyy年M月"
                value-format="yyyy-MM-dd"
                clearable
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="filter-item middle-filter-item">
          <div class="item-label">
            结束时间
          </div>
          <div class="item-component">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="filter.endDate"
                type="month"
                placeholder="选择月"
                format="yyyy年M月"
                value-format="yyyy-MM-dd"
                clearable
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="filter-item small-filter-item">
          <div class="item-label">
            指标类型
          </div>
          <div class="item-component">
            <div class="el-select-wrapper kpi-type-select-wrapper">
              <el-select v-model="filter.kpiType.value" clearable placeholder="请选择" @change="onKpiTypeChange">
                <el-option v-for="item in filter.kpiType.options" :key="item.code" :value="item.code"
                           :label="item.name"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="filter-item small-filter-item">
          <div class="item-label">
            指标编号
          </div>
          <div class="item-component">
            <div class="el-input-wrapper kpi-code-select-wrapper">
              <el-input placeholder="请输入内容" v-model="filter.kpiCode.value" clearable
                        @change="buildTable"></el-input>
            </div>
          </div>
        </div>
        <div class="filter-item middle-filter-item">
          <div class="item-label">
            指标名称
          </div>
          <div class="item-component">
            <div class="el-input-wrapper">
              <el-input placeholder="请输入内容" v-model="filter.kpiName.value" clearable
                        @change="buildTable"></el-input>
            </div>
          </div>
        </div>
        <div class="filter-item middle-filter-item">
          <div class="item-label">
            机型
          </div>
          <div class="item-component">
            <div class="el-select-wrapper">
              <el-select v-model="filter.airType.value" multiple collapse-tags clearable placeholder="请选择"
                         @change="onAirTypeChange">
                <el-option v-for="item in filter.airType.options" :key="item.code" :value="item.code"
                           :label="item.name"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-list">
        <div class="filter-item middle-filter-item">
          <div class="item-label">
            责任部门
          </div>
          <div class="item-component">
            <div class="el-select-wrapper">
              <el-select v-model="filter.respDept.value" clearable placeholder="请选择" @change="onRespDeptChange">
                <el-option v-for="item in filter.respDept.options" :key="item.id" :value="item.id"
                           :label="item.name"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="filter-item middle-filter-item">
          <div class="item-label">
            预警等级
          </div>
          <div class="item-component">
            <div class="el-select-wrapper">
              <el-select v-model="filter.warningLevel.value" clearable placeholder="请选择"
                         @change="onWarningLevelChange">
                <el-option v-for="item in filter.warningLevel.options" :key="item.code" :value="item.code"
                           :label="item.name"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="filter-item small-filter-item">
          <div class="item-label">
            处理状态
          </div>
          <div class="item-component">
            <div class="el-select-wrapper process-status-select-wrapper">
              <el-select v-model="filter.processStatus.value" clearable placeholder="请选择"
                         @change="onProcessStatusChange">
                <el-option v-for="item in filter.processStatus.options" :key="item.code" :value="item.code"
                           :label="item.name"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="filter-item process-desc-filter-item">
          <div class="item-label">
            处理说明
          </div>
          <div class="item-component">
            <div class="el-input-wrapper process-desc-input-wrapper">
              <el-input placeholder="请输入内容" v-model="filter.processDesc.value" clearable
                        @change="buildTable"></el-input>
            </div>
          </div>
        </div>
        <div class="filter-item middle-filter-item btn-filter-item">
          <el-button size="small" type="primary" @click="buildTable">查询</el-button>
          <el-button size="small" @click="onFilterResetClick">重置</el-button>
        </div>
      </div>
      <div ref="table" class="el-table-wrapper">
        <!--max-height与el-table-wrapper高度保持一致-->
        <el-table :data="standardDangerData" header-cell-class-name="custom-table-header-cell"
                  cell-class-name="cell-class" max-height="500">
          <el-table-column label="No." prop="index" width="50" align="center"></el-table-column>
          <el-table-column prop="kpiTypeText" label="指标类型" align="center"></el-table-column>
          <el-table-column prop="kpiCode" label="指标编号" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="middle" @click="onKpiCodeClick(scope.row)">
                {{ scope.row.kpiCode }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="dateText" label="月份" align="center">
          </el-table-column>
          <el-table-column prop="kpiName" label="指标名称" align="center" width="130"></el-table-column>
          <el-table-column prop="kpiExplain" label="指标说明" align="center" width="130"></el-table-column>
          <el-table-column prop="airTypeText" label="机型" align="center" width="70"></el-table-column>
          <el-table-column prop="actualValue" label="实际值" align="center" width="90">
            <template slot-scope="scope">
              <div class="actual-value-box" :class="$util.getRiskLevelBgColor(scope.row.color)">
                {{ scope.row.actualValue }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="warningTime" label="告警时间" align="center"></el-table-column>
          <el-table-column prop="processStatusText" label="处理状态" align="center">
            <template slot-scope="scope">
              <div class="process-status-box"
                   :class="{'risk-level-color-red' : (scope.row.processStatus === 'UNTREATED')}">
                {{ scope.row.processStatusText }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.processStatus==='UNTREATED' && (scope.row.color==='YELLOW' || scope.row.color==='RED')"
                type="text" size="small"
                @click="onProcessClick(scope.row)" :disabled="!permission.process">处理
              </el-button>
              <el-button
                v-if="scope.row.processStatus==='UNTREATED' && (scope.row.color==='YELLOW' || scope.row.color==='RED')"
                type="text" size="small"
                @click="onIgnoreClick(scope.row)"
                :disabled="!permission.ignore">忽略
              </el-button>
              <el-button v-if="scope.row.processStatus==='IGNORE'" type="text" size="small"
                         @click="onCancelIgnoreClick(scope.row)"
                         :disabled="!permission.ignore">取消忽略
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="processDesc" label="处理说明" align="center" width="100" :show-overflow-tooltip="true">
            <!--如果是已处理状态，将处理说明改成风险评估单链接-->
            <template slot-scope="scope">
              <el-link v-for="info in scope.row.riaActivitiesInfoList" v-if="scope.row.processStatus==='PROCESSED'"
                       :key="info.id"
                       type="primary" :underline="false" target="_blank"
                       :href="$util.buildSmsActivityDetailUrl(info.id)">
                {{ info.activityNo }}
              </el-link>
              <div v-if="scope.row.processStatus!=='PROCESSED'" class="overflow-ellipsis">
                {{ scope.row.processDesc }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="processorName" label="处理人" align="center"></el-table-column>
          <el-table-column prop="processTime" label="处理时间" align="center"></el-table-column>
        </el-table>
      </div>
      <div class="page-wrapper">
        <el-pagination background layout="prev, pager, next" :total="page.total" :current-page.sync="page.num"
                       :page-size.sync="page.size">
        </el-pagination>
      </div>
      <el-dialog title="KPI图表" :visible.sync="kpiChart.visible" width="60%" @close="onKpiChartDialogClose">
        <KpiChart ref="kpiChartRef" v-if="kpiChart.kpiCode" :kpiCode="kpiChart.kpiCode" :year="Number(kpiChart.year)"
                  :default-air-type="kpiChart.airType"></KpiChart>
      </el-dialog>
      <el-dialog custom-class="ria-activity-dialog" title="新建风险评估单" width="650px"
                 :visible.sync="riaActivity.visible"
                 :destroy-on-close="true"
                 :close-on-click-modal="false">
        <div ref="riaActivityFormBox" class="el-form-wrapper">
          <el-form ref="riaActivityForm" label-position="right" label-width="80px" :model="riaActivity.values"
                   :rules="riaActivity.form.rules" size="mini">
            <el-form-item label="所属机构" prop="company">
              <div class="el-select-wrapper">
                <el-select v-model="riaActivity.values.company" placeholder="请选择"
                           :disabled="companyOptions.length === 1"
                           @change="onCompanyChange">
                  <el-option v-for="item in companyOptions" :key="item.code"
                             :label="item.shortName ? item.shortName : item.name" :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <div class="el-select-wrapper">
                <!--纯展示用-->
                <el-select disabled value>
                  <el-option label="风险评估单" value>
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item label="编号" prop="serialNumber">
              <div class="el-input-wrapper">
                <el-input v-model="riaActivity.values.serialNumber"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="主题" prop="summary">
              <div class="el-input-wrapper">
                <el-input type="textarea" v-model="riaActivity.values.summary"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="详细描述" prop="description">
              <div class="el-input-wrapper">
                <el-input type="textarea" v-model="riaActivity.values.description"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="责任部门" prop="respDept">
              <div class="el-select-wrapper">
                <!--纯展示用-->
                <el-select multiple v-model="riaActivity.values.respDepts">
                  <el-option v-for="item in filter.respDept.options" :key="item.id" :value="item.id"
                             :label="item.name"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="结案时限" prop="processDeadline">
              <div class="el-date-picker-wrapper">
                <el-date-picker v-model="riaActivity.values.processDeadline" type="date"
                                format="yyyy年M月d日" value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="来源" prop="source">
              <div class="el-select-wrapper">
                <!--纯展示用-->
                <el-select disabled value>
                  <el-option label="核心风险" value>
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="附件" prop="attachment">
              <el-upload
                class="upload-demo"
                action="string"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="3"
                :http-request="onUploadfiles"
                :on-exceed="handleExceed"
                :file-list="fileList">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
              <el-button @click="useChartAttachment">使用系统已有图表作为附件</el-button>
            </el-form-item>
            <el-form-item class="btn-container">
              <el-button type="primary" @click="onSubmitClick">确认</el-button>
              <el-button @click="onCancelClick">取消</el-button>
            </el-form-item>
          </el-form>
        </div>

      </el-dialog>
      <el-dialog custom-class="ria-activity-dialog" :title="supActivity.values.title" width="650px"
                 :visible.sync="supActivity.visible"
                 :destroy-on-close="true"
                 :close-on-click-modal="false">
        <div ref="supActivityFormBox" class="el-form-wrapper" style="margin-left: 30px;">
          <el-form ref="supActivityForm" label-position="right" label-width="100px" :model="supActivity.values"
                   :rules="supActivity.form.rules" size="mini">
            <el-form-item label="所属机构" prop="company">
              <div class="el-select-wrapper">
                <el-select v-model="supActivity.values.company" placeholder="请选择"
                           :disabled="companyOptions.length === 1"
                           @change="onCompanyChange">
                  <el-option v-for="item in companyOptions" :key="item.code"
                             :label="item.shortName ? item.shortName : item.name" :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <div class="el-select-wrapper">
                <el-select v-model="supActivity.values.type" @change="onTypeChange">
                  <el-option v-for="item in this.typeOptions" :key="item.code" :value="item.code"
                             :label="item.name"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="类别" prop="categoryType">
              <div class="el-select-wrapper">
                <el-select v-model="supActivity.values.categoryType">
                  <el-option v-for="item in this.categoryOptions" :key="item.code" :value="item.code"
                             :label="item.name"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item label="主题" prop="summary">
              <div class="el-input-wrapper">
                <el-input type="textarea" v-model="supActivity.values.summary"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="工作来源" prop="workSource">
              <div class="el-select-wrapper">
                <el-select v-model="supActivity.values.workSource">
                  <el-option v-for="item in supActivity.values.workSourceOptions" :key="item.srcId" :value="item.value"
                             :label="item.name"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="被检查单位" prop="checkOrg">
              <div class="el-select-wrapper">
                <el-tree ref="checkOrgTree" :data="supActivity.form.checkOrgTree.data"
                         node-key="id"
                         :props="supActivity.form.checkOrgTree.defaultProps"
                         show-checkbox :check-strictly="true"
                         @check-change="supActivity.form.checkOrgTree.handleCheckChange"></el-tree>
              </div>
            </el-form-item>
            <el-form-item label="详细描述" prop="description">
              <div class="el-input-wrapper">
                <el-input type="textarea" v-model="supActivity.values.description"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="检查年度" prop="checkYear">
              <div class="el-select-wrapper">
                <el-select v-model="supActivity.values.checkYear">
                  <el-option v-for="item in supActivity.values.checkYearOptions" :key="item.srcId" :value="item.value"
                             :label="item.name"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="检查月份" prop="checkMonth">
              <div class="el-select-wrapper">
                <el-select multiple v-model="supActivity.values.checkMonth">
                  <el-option v-for="item in supActivity.values.checkMonthOptions" :key="item.srcId" :value="item.value"
                             :label="item.name"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="检查次数" prop="checkTimes">
              <div class="el-input-wrapper">
                <el-input v-model="supActivity.values.checkTimes"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="检查城市" prop="checkCity">
              <div class="el-select-wrapper">
                <el-select v-model="supActivity.values.checkCity">
                  <el-option v-for="item in supActivity.values.checkCityOptions" :key="item.srcId" :value="item.srcId"
                             :label="item.name"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="检查地点" prop="checkPlace">
              <div class="el-input-wrapper">
                <el-input type="textarea" v-model="supActivity.values.checkPlace"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="标准工时" prop="standardWorkHour">
              <div class="el-input-wrapper">
                <el-input v-model="supActivity.values.standardWorkHour"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <div class="el-input-wrapper">
                <el-input type="textarea" v-model="supActivity.values.remark"></el-input>
              </div>
            </el-form-item>
            <el-form-item class="btn-container">
              <el-button type="primary" @click="onSubmitClick">确认</el-button>
              <el-button @click="onCancelClick">取消</el-button>
            </el-form-item>
          </el-form>
        </div>

      </el-dialog>
    </div>
  </div>
</template>

<script>
import {getRequestSms, postMultiPartRequestSms, postRequestSms} from "../../utils/requestForSms";
import KpiChart from "./risk/KpiChart";
import {getRequest, postRequest} from "../../utils/request";
import {showMessage} from "../../utils/notice";

export default {
  props: {
    //用户当前航司
    company: String,
    //用户可选航司
    companyOptions: Array,
    //当前用户
    username: String,
  },
  components: {KpiChart},
  data: function () {
    const checkTimesRule = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('检查次数不能为空'));
      }
      let ruleInt = /^[0-9]+$/;
      if (ruleInt.test(value) && value < 6) {
        callback();
      } else {
        return callback(new Error('请输入不超过5的正整数'));
      }
    };
    return {
      kpiChart: {
        visible: false,
        kpiCode: null,
        year: null,
        airType: null,
      },
      fileList: [],
      //SMS风险评估流程单
      riaActivity: {
        //对话框可见
        visible: false,
        //值
        values: {
          //默认等于用户登陆航司（大新华需要转）
          company: this.company === "CN" ? "DXHHK" : this.company,
          type: "RISK_ASSESSMENT",
          dataId: null,
          kpiCode: null,
          serialNumber: null,
          summary: null,
          description: null,
          processDeadline: null,
          respDept: null,
          respDepts: null,
          source: "CORE_RISK",
        },
        //表单相关
        form: {
          typeOptions: [{}],
          rules: {
            company: [
              {required: true},
            ],
            type: [
              {required: true},
            ],
            serialNumber: [
              {required: true, message: '请输入编号', trigger: 'blur'},
            ],
            summary: [
              {required: true, message: '请输入主题', trigger: 'blur'},
            ],
            description: [
              {required: true, message: '请输入详细描述', trigger: 'blur'},
            ],
            respDept: [
              {required: true},
            ],
            respDepts: [
              {required: true},
            ],
            processDeadline: [
              {required: true, message: '请选择结案时限', trigger: 'blur'},
            ],
            source: [
              {required: true},
            ],
          }
        }
      },
      //SMS日常监察任务单或审核监察任务单
      supActivity: {
        //对话框可见
        visible: false,
        //值
        values: {
          //默认等于用户登陆航司（大新华需要转）
          company: this.company === "CN" ? "DXHHK" : this.company,
          type: null,
          dataId: null,
          categoryType: null,
          summary: null,
          workSource: null,
          checkOrg: null,
          description: null,
          checkYear: null,
          checkMonth: null,
          checkTimes: null,
          checkCity: null,
          checkPlace: null,
          standardWorkHour: null,
          remark: null,
          title: null,
          workSourceOptions: null,
          checkYearOptions: null,
          checkMonthOptions: null,
          checkCityOptions: null,
        },
        //表单相关
        form: {
          typeOptions: [{}],
          checkOrgTree: {
            data: [],
            defaultProps: {
              children: 'children',
              label: 'name'
            },
            handleCheckChange: (data, checked, indeterminate) => {
              if (checked) {
                this.$refs.checkOrgTree.setCheckedKeys([data.id]);
                this.supActivity.values.checkOrg = data.id;
              }
            },
          },
          rules: {
            company: [
              {required: true},
            ],
            type: [
              {required: true},
            ],
            categoryType: [
              {required: true},
            ],
            summary: [
              {required: true, message: '请输入主题', trigger: 'blur'},
            ],
            workSource: [
              {required: true, message: '请选择工作来源', trigger: 'blur'},
            ],
            checkOrg: [
              {required: true, message: '请选择被检查单位', trigger: 'blur'},
            ],
            description: [
              {required: true, message: '请输入详细描述', trigger: 'blur'},
            ],
            checkYear: [
              {required: true, message: '请选择检查年度', trigger: 'blur'},
            ],
            checkMonth: [
              {required: true, message: '请选择检查月份', trigger: 'blur'},
            ],
            checkTimes: [
              {required: true, validator: checkTimesRule, trigger: 'blur'},
            ],
            checkPlace: [
              {required: true, message: '请输入检查地点', trigger: 'blur'},
            ],
            standardWorkHour: [
              {required: true, message: '请输入标准工时', trigger: 'blur'},
              {pattern: /^([1-9]\d*|[0]{1,1})$/, message: '请输入正整数'},
            ],
          }
        }
      },
      filter: {
        startDate: null,
        endDate: null,
        kpiType: {
          value: null,
          options: []
        },
        kpiCode: {
          value: null
        },
        kpiName: {
          value: null
        },
        processDesc: {
          value: null
        },
        airType: {
          value: null,
          options: []
        },
        respDept: {
          value: null,
          options: []
        },
        warningLevel: {
          value: null,
          options: []
        },
        processStatus: {
          value: null,
          options: [
            {
              code: "UNTREATED",
              name: "未处理",
            }, {
              code: "PROCESSED",
              name: "已处理",
            }, {
              code: "IGNORE",
              name: "忽略",
            }
          ]
        },
      },
      //分页
      page: {
        num: 1,
        size: 10,
        total: null,
      },
      tableData: [],
      permission: {
        process: false,
        ignore: false,
      },
      typeOptions: [],
      categoryOptions: [],
      categoryTypeMap: null,
      dataSummary: String,
      currentKpiType: String,
    }
  },
  mounted() {
    postRequestSms("/query.do", {
      method: "getPermissions",
      permissionSets: "PROCESS_SP_KPI_WARNING_MONITOR",
    }).then(res => {
      let data = res.data;
      //如果包含当前用户所选机构，则视为有权限
      let unit = data.units.find(unit => {
        if (unit.code === this.company || unit.code === "DXHHK" && this.company === "CN") {
          return unit;
        }
      })
      let orgUnit = data.orgUnits.find(unit => {
        if (unit.code === this.company || unit.code === "DXHHK" && this.company === "CN") {
          return unit;
        }
      })
      this.permission.process = !!unit || !!orgUnit;
      this.permission.ignore = !!unit || !!orgUnit;

      //query参数处理
      if (this.$route.query.startDate) {
        this.filter.startDate = this.$route.query.startDate;
      } else {
        this.filter.startDate = new Date(new Date().setDate(1)).format("yyyy-MM-dd");
      }
      if (this.$route.query.endDate) {
        this.filter.endDate = this.$route.query.endDate;
      } else {
        this.filter.endDate = new Date(new Date().setDate(1)).format("yyyy-MM-dd");
      }
      if (this.$route.query.kpiType) {
        this.filter.kpiType.value = this.$route.query.kpiType;
      }
      if (this.$route.query.kpiCode) {
        this.filter.kpiCode.value = this.$route.query.kpiCode;
      }
      if (this.$route.query.kpiName) {
        this.filter.kpiName.value = this.$route.query.kpiName;
      }
      if (this.$route.query.color) {
        this.filter.warningLevel.value = this.$route.query.color;
      }
      this.buildTable();
    });
    this.kpiTypeOptions();
    this.airTypeOptions();
    this.respOrganizations();
    this.warningLevelOptions();
    this.workSourceOptions();
    this.checkYearOptions();
    this.checkMonthOptions();
    this.checkCityOptions();
    this.getCreateActivityPermissionType();
    this.checkOrgTree();
  },
  methods: {
    buildTable: function () {
      postRequest("/kpiRiskLevel/kpiWarningMonitor/list", {
        startTime: this.filter.startDate,
        endTime: this.filter.endDate,
        kpiType: this.filter.kpiType.value,
        kpiCode: this.filter.kpiCode.value,
        kpiName: this.filter.kpiName.value,
        airTypeList: this.filter.airType.value,
        respDept: this.filter.respDept.value,
        color: this.filter.warningLevel.value,
        processStatus: this.filter.processStatus.value,
        processDesc: this.filter.processDesc.value,
      }, {
        pageNum: this.page.num,
        pageSize: this.page.size,
      }, this.$refs.table).then(res => {
        this.tableData = res.data.records
        this.page.total = res.data.total
      })
    },
    // 附件
    onUploadfiles(file){
      const formData = new FormData();
      formData.append("upload",file.file);
      postMultiPartRequestSms("/modify.do?method=uploadFiles", {
        sourceType: 3,
        attachmentType: 0,
      }, formData).then(res => {
        let arr = res.data.aaData;
        for (var i = 0; i < arr.length; i++){
          this.fileList.push({ id: arr[i].id, name: arr[i].fileName, path: arr[i].relativePath });
        }
      })
      console.log(this.fileList);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.filter((item) => item.id != file.id);
    },
    handlePreview(file) {
      // 点击上传附件触发事件 后续可能需要
      // console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },

    kpiTypeOptions: function () {
      getRequest("/risk/dwkpi/type/options")
        .then(res => {
          this.filter.kpiType.options = res.data;
        })
    },
    airTypeOptions: function () {
      getRequest("/kpiRiskLevel/monitoring/air-types")
        .then(res => {
          this.filter.airType.options = res.data.map(item => {
            return {code: item, name: item === "ALL" ? "全部" : item}
          })
        })
    },
    respOrganizations: function () {
      getRequest("/kpiRiskLevel/monitoring/resp/organizations")
        .then(res => {
          this.filter.respDept.options = res.data;
        })
    },
    warningLevelOptions: function () {
      getRequest("/kpiRiskLevel/monitoring/risk-level/options")
        .then(res => {
          this.filter.warningLevel.options = res.data;
        })
    },
    workSourceOptions: function () {
      getRequest("/dictionary/list", {type: "supWorkSource"})
        .then(res => {
          this.supActivity.values.workSourceOptions = res.data;
        })
    },
    checkYearOptions: function () {
      getRequest("/dictionary/list", {type: "inspectYear"})
        .then(res => {
          this.supActivity.values.checkYearOptions = res.data;
        })
    },
    checkMonthOptions: function () {
      getRequest("/dictionary/list", {type: "inspectMonth"})
        .then(res => {
          this.supActivity.values.checkMonthOptions = res.data;
        })
    },
    checkCityOptions: function () {
      getRequest("/dictionary/list", {type: "PROVINCIAL_CAPITAL"})
        .then(res => {
          this.supActivity.values.checkCityOptions = res.data;
        })
    },
    checkOrgTree() {
      getRequestSms("query.do", {
        method: "getTreeNodesByUnit",
        unitId: this.companyOptions.find(item => item.code === this.company).srcId,
      }).then(res => {
        this.supActivity.form.checkOrgTree.data = [res.data]
      })
    },
    getCreateActivityPermissionType: function () {
      let supTypeCodeArray = ["SUP_DAILY", "SUP_AUDIT"];
      postRequestSms("/query.do", {
        method: "getCreateActivityPermissionType",
        unitCode: this.company,
        typeCodeArray: JSON.stringify(supTypeCodeArray),
      }).then(res => {
        if (res.success) {
          let typeData = res.types;
          if (typeData != null && typeData !== '') {
            typeData.forEach(activityType => {
              this.typeOptions.push(activityType);
            })
          }
          let categoryTypeData = res.categoryTypeMap;
          if (categoryTypeData != null && categoryTypeData !== '') {
            this.categoryTypeMap = categoryTypeData;
          }
        } else {
          showMessage("获取创建安全信息类型权限失败，请联系管理员！", "error");
          return false;
        }
      });
    },
    onFilterResetClick: function () {
      this.filter.kpiType.value = null;
      this.filter.kpiCode.value = null;
      this.filter.kpiName.value = null;
      this.filter.airType.value = null;
      this.filter.respDept.value = null;
      this.filter.warningLevel.value = null;
      this.filter.processStatus.value = null;
      this.filter.processDesc.value = null;
      this.buildTable();
    },
    onSubmitClick: function () {
      if (this.currentKpiType === "KP") {
        this.supActivitySubmit();
      } else {
        this.riaActivitySubmit();
      }
    },
    onCancelClick: function () {
      this.fileList = [];
      this.riaActivity.visible = false;
      this.supActivity.visible = false;
      this.kpiChart.visible = false;
    },
    riaActivitySubmit: function () {
      let attachments = [];
      for (const obj of this.fileList) {
        attachments.push(obj.id);
      }
      this.$refs.riaActivityForm.validate((valid) => {
        if (valid) {
          postRequestSms("/modify.do", {
            method: "createRiskAssessmentActivity",
            dataType: "activity",
            dataMap: JSON.stringify(this.riaActivity.values),
            attachments: JSON.stringify(attachments),
          }, this.$refs.riaActivityFormBox).then(res => {
            //保存到KPI告警处理表
            showMessage("创建风险评估单成功");
            this.riaActivity.visible = false;
            this.kpiChart.visible = false;
            return postRequest("/kpi/warning/post-process", {
              riaActivitiesInfo: JSON.stringify(res.data),
              dataId: this.riaActivity.values.dataId,
            }, {});
          }).then(res => {
            this.fileList = [];
            this.buildTable();
          })
        } else {
          return false;
        }
      });
    },
    supActivitySubmit: function () {
      this.$refs.supActivityForm.validate((valid) => {
        if (valid) {
          postRequestSms("/modify.do", {
            method: "createSupActivity",
            dataMap: JSON.stringify(this.supActivity.values),
          }, this.$refs.supActivityFormBox).then(res => {
            //保存到KPI告警处理表
            if (this.supActivity.values.type === "SUP_DAILY") {
              showMessage("创建日常监察任务单成功");
            } else if (this.supActivity.values.type === "SUP_AUDIT") {
              showMessage("创建专项审核任务单成功");
            }
            this.supActivity.visible = false;
            return postRequest("/kpi/warning/post-process", {
              riaActivitiesInfo: JSON.stringify(res.data),
              dataId: this.supActivity.values.dataId,
              //riaActivityId: res.data.id,
              //riaActivityNo: res.data.unit.code + "-" + res.data.num,
            }, {});
          }).then(res => {
            this.buildTable();
          })
        } else {
          return false;
        }
      });
    },
    onCompanyChange: function () {

    },
    onProcessClick: function (row) {
      let kpiTypeText = row.kpiTypeText;
      if (kpiTypeText === "关键流程类") {
        this.supActivityProcess(row);
      } else {
        this.onKpiCodeClick(row);
        this.riaActivityProcess(row);
      }
    },
    supActivityProcess: function (row) {
      this.supActivity.visible = true;
      if (this.typeOptions.size === 0) {
        showMessage("您没有创建日常检查任务单或专项审核任务单的权限！", "error");
        return false;
      }
      this.supActivity.values.type = this.typeOptions[0].code;
      this.categoryOptions = this.categoryTypeMap[this.supActivity.values.type];
      this.supActivity.values.categoryType = this.categoryOptions[0].code;
      if (this.supActivity.values.type === "SUP_DAILY") {
        this.supActivity.values.title = "新建日常监察任务单";
        this.supActivity.values.summary = this.dataSummary + "日常监察";
      } else if (this.supActivity.values.type === "SUP_AUDIT") {
        this.supActivity.values.title = "新建专项审核任务单";
        this.supActivity.values.summary = this.dataSummary + "专项审核";
      }
      let reportType = this.supActivity.values.type === "SUP_DAILY" ? "日常监察" : "专项审核";
      this.dataSummary = "关于KPI（" + row.kpiName + "）指标" + row.colorText + "预警状态的";
      this.supActivity.values.summary = this.dataSummary + reportType;
      this.supActivity.values.dataId = row.dataId;
      this.supActivity.values.workSource = null;
      this.supActivity.values.checkOrg = null;
      this.supActivity.values.description = null;
      this.supActivity.values.checkYear = null;
      this.supActivity.values.checkMonth = null;
      this.supActivity.values.checkTimes = null;
      this.supActivity.values.checkCity = null;
      this.supActivity.values.checkPlace = null;
      this.supActivity.values.standardWorkHour = null;
      this.supActivity.values.remark = null;
      this.currentKpiType = row.kpiCode.substring(0, 2);
    },
    riaActivityProcess: function (row) {
      this.riaActivity.values.respDept = row.respDept;
      this.riaActivity.values.summary = "关于KPI（" + row.kpiName + "）指标" + row.colorText + "预警状态的风险评估";
      this.riaActivity.values.dataId = row.dataId;
      this.riaActivity.values.kpiCode = row.kpiCode;
      this.riaActivity.visible = true;
      this.riaActivity.values.serialNumber = null;
      this.riaActivity.values.description = null;
      this.riaActivity.values.respDepts = null;
      this.currentKpiType = row.kpiCode.substring(0, 2);
    },
    onIgnoreClick: function (row) {
      this.$prompt('请填写忽略理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        postRequest("/kpiRiskLevel/kpiWarningMonitor/ignore", {
          dataId: row.dataId,
          reason: value,
        }, {}).then(res => {
          showMessage("已忽略");
          this.buildTable();
        })
      });
    },
    onCancelIgnoreClick: function (row) {
      this.$prompt('请填写取消忽略理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        postRequest("/kpiRiskLevel/kpiWarningMonitor/cancelIgnore", {
          dataId: row.dataId,
          reason: value,
        }, {}).then(res => {
          showMessage("已取消忽略");
          this.buildTable();
        })
      });
    },
    /**
     * 使用kpiChart生成的图片作为附件
     */
    useChartAttachment() {
      let dataUrl = this.$refs.kpiChartRef.getDataURL();
      let filename = `关于KPI（${this.kpiChart.kpiName}）${this.kpiChart.year}年${this.kpiChart.airType}机型${this.kpiChart.colorText}预警状态的风险评估`;
      let file = this.$util.base64ToFile(dataUrl, filename + ".png");
      this.onUploadfiles({file});
    },
    /**
     * 对话框关闭时，销毁KPI图表
     */
    onKpiChartDialogClose: function () {
      this.kpiChart.kpiCode = null;
    },
    /**
     * 点击KPI编号时，弹出KPI图表
     * @param row
     */
    onKpiCodeClick: function (row) {
      this.kpiChart.year = row.year;
      this.kpiChart.kpiCode = row.kpiCode;
      this.kpiChart.airType = row.airType;
      this.kpiChart.kpiName = row.kpiName;
      this.kpiChart.colorText = row.colorText;
      this.kpiChart.visible = true;
    },
    onStartDateChange: function () {
      this.buildTable();
    },
    onEndDateChange: function () {
      this.buildTable();
    },
    onKpiTypeChange: function () {
      this.buildTable();
    },
    onAirTypeChange: function () {
      this.buildTable();
    },
    onRespDeptChange: function () {
      this.buildTable();
    },
    onProcessStatusChange: function () {
      this.buildTable();
    },
    onWarningLevelChange: function () {
      this.buildTable();
    },
    onTypeChange: function () {
      this.categoryOptions = this.categoryTypeMap[this.supActivity.values.type];
      this.supActivity.values.categoryType = this.categoryOptions[0].code;
      if (this.supActivity.values.type === "SUP_DAILY") {
        this.supActivity.values.title = "新建日常监察任务单";
        this.supActivity.values.summary = this.dataSummary + "日常监察";
      } else if (this.supActivity.values.type === "SUP_AUDIT") {
        this.supActivity.values.title = "新建专项审核任务单";
        this.supActivity.values.summary = this.dataSummary + "专项审核";
      }
    },
  },
  computed: {
    standardDangerData() {
      let index = 1;
      return this.tableData.map(item => {
        item.kpiTypeText = item.kpiType;
        item.dateText = item.year + "年" + item.month + "月";
        item.airTypeText = item.airType ? (item.airType === "ALL" ? "全部" : item.airType) : "/";
        item.actualValue = item.actualValue == null ? "无" : item.actualValue;
        item.processStatusText = item.processStatusName;
        item.processorName = item.fullName;

        //序号
        item.index = index;
        index++;
        return item;
      })
    }
  },
  watch: {
    "page.num"() {
      this.buildTable();
    },
    company() {
      location.reload();
    },
  }
}
</script>

<style scoped lang="less">
.sms-content-main {
  background-color: #fff;
  border-radius: 10px;
  padding: 13px 50px;
}

//过滤组件定制样式
.filter-list {

  .filter-item {
    .item-label {
      font-size: 13px;
      font-weight: bold;
    }

    .item-component {
      flex: 1;
    }
  }

  .filter-item:not(:first-child) {
    margin-left: 2.4%;
  }

  .middle-filter-item {
    width: 16%;
  }

  .small-filter-item {
    width: 12%;
  }

  //由于第2行只有5个组件，共4个margin，2.4*4=9.6，16*3+12+30.4=90.4
  .process-desc-filter-item {
    width: 30.4%;
  }

  .btn-filter-item {
    justify-content: end;
  }
}

//日期选择器定制样式
.el-date-picker-wrapper {
  /deep/ .el-date-editor {
    width: 100%;
  }

  /deep/ .el-input__inner {
    font-size: 13px;
    height: 33px;
    line-height: 33px;
  }

  /deep/ .el-input__icon {
  }
}

//下拉选定制样式
.el-select-wrapper {
  /deep/ .el-select {
    width: 100%;
  }

  /deep/ .el-input__inner {
    font-size: 13px;
    height: 33px;
    line-height: 33px;
  }
}

//文本框定制样式
.el-input-wrapper {
  /deep/ .el-input__inner {
    font-size: 13px;
    height: 33px;
    line-height: 33px;
  }
}

//指标类型
.kpi-type-select-wrapper {
  /deep/ .el-input__inner {
  }
}

//处理状态
.process-status-select-wrapper {
  /deep/ .el-input__inner {
  }
}

.process-desc-input-wrapper {
  /deep/ .el-input__inner {
  }
}

//指标编号
.kpi-code-select-wrapper {
  /deep/ .el-input__inner {
  }
}

//表格公共样式
.el-table-wrapper {
  margin-top: 10px;
  height: 500px;

  //滚动条公共样式
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 3px;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #c8c8c8;
  }

  /deep/ .custom-table-header-cell {
    background-color: #2a3247;
    border: 0 !important;
    padding: 7px 0;
    color: #fff;
    font-size: 13px;
  }

  /deep/ .cell-class {
    font-size: 13px;
    padding: 0;
    color: #000
  }

  .actual-value-box {
    padding: 5px 0;
    border-radius: 3px;
  }

  .process-status-box {
    //color: red;
  }
}

.page-wrapper {
  text-align: right;
  margin-top: 10px;
}

/deep/ .ria-activity-dialog {
  border-radius: 5px;
}

//表单定制样式
.el-form-wrapper {
  width: 500px;
  margin: 0 auto;

  /deep/ .el-form-item {
    margin-bottom: 12px;
  }

  /deep/ .el-divider {
    margin: 12px 0;
  }

  //按钮靠右
  .btn-container {
    text-align: right;
    margin-top: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/KpiMonitoring.vue